import { Pipe, PipeTransform } from '@angular/core';
import DateHelper from '../helpers/date-helper';

@Pipe({
  name: 'formatASAPDate'
})
export class FormatASAPDate implements PipeTransform {
  transform(value: Date, asap: boolean) {
    if (value == null) {
      return asap ? 'ASAP' : '-';
    } else {
      return DateHelper.formatDate(value);
    }
  }
}
